<style>
	.bg6632 {
		background-color: #fff;width:100%; 
	}
 
 
.draw-enter-active, .draw-leave-active {
     transition: opacity 0.2s;
}
.draw-enter, .draw-leave-to /* .fade-leave-active below version 2.1.8 */ {
     opacity: 0;
}
.top_area{width:100%;height:4vw;position:fixed;top:1vw;left:0; }
.top_area img{display:block;float:left;height:4vw; }
.tabbar11{width:84vw;height:4vw;background:url(../../assets/images/tabbar_bg.png) center center; border-radius:.5vw;
float:left;margin-left:2.5vw;background-size:105% 105%;cursor:pointer; }
.tabbar11 span{display:block;float:left;line-height:4vw;font-size:1.4vw;}
.tabbar11 span.pos{ padding:0 1vw;}
.tabbar11 span.floder{  color:#3268ff;}
.tabbar11 span.rights{background:url(../../assets/images/right.png) no-repeat;width:2vw;
height:4vw;background-position:center center;background-size:2vw;}
 
.pagessss{margin:0 auto;padding:0;overflow:hidden;width:84vw;height:4vw; margin-top:2vw;} 
 
.submits2111{width:12vw;height:4vw;border-radius:.5vw;float:right;background:#ccc;}
.submits2111 button{background:#3268ff;outline:none;border:0;font-size:1.2vw;display:block;height:4vw;line-height:4vw;width:100%;color:#fff;border-radius:.5vw;}
.send_view{width: 85vw;height: 36vw; margin-top:12vw;border-bottom: #bbb solid 1px;}
.send_view_left{width: 35vw;float: left;height:36vw; position: relative;overflow: hidden;margin-left: 5vw;}
.send_view_left img{display: block;position: absolute;width: 35vw;z-index: 999;}
.send_view_left span{display: block;position: absolute;top: 3vw;left: 4vw;z-index: 99999;font-size: 1.3vw;font-weight: bold;}
.sms_box{width: 29.5vw;  position:absolute ;z-index: 9999;top:14vw;left: 2.5vw;}
.sms_box p{line-height: 2vw;font-size: 1.2vw;width: 26vw;word-break: break-all;word-wrap: break-word; display: block;margin: 0 auto;

 height: 17vw; 
	overflow-y: auto;}
.send_view_right{width: 38vw;float: right;height:34vw; position: relative;overflow: hidden;margin-top:2vw; }
.send_view_right img.tips{width: 2.5vw;}
.send_view_right p{line-height: 3vw;font-size: 1.3vw;}
.send_view_right img.icon{width: 8vw;bottom: 0;position: absolute;}
.send_view_right span{display: block;position: absolute;top: 0vw;left: 3vw;line-height: 3vw;font-size: 1.4vw;font-weight: bold;}
.sms_head{width:100%;height: 1.5vw;background-image: url(../../assets/images/sms_01.png);background-size: 100% 100%;}
.sms_body{width:100%; background-image: url(../../assets/images/sms_02.png);background-size: 100% 100%;background-repeat: repeat;height: 17vw;}
.sms_foot{width:100%;height: 1.5vw;background-image: url(../../assets/images/sms_03.png);background-size: 100% 100%;}
</style>
 
<template>
	<div class="bg6632">
		     
	     <u_center  ></u_center>
	     <div class="top_area">
		    <img @click="home()" src="../../assets/images/home_icon.png">
			<div class="tabbar11">
			   <span class="pos">您的当前位置:</span>
			   <span class="floder">短信模板</span>
			   <span class="rights"></span>
			   <span class="floder">模板预览</span>
			   
			</div>
		 </div>
	      <div class="send_view">
                <div class="send_view_left">
                	<img src="../../assets/images/iphone.png">
                	<div class="sms_box">
                		<div class="sms_head"></div>
                		<div class="sms_body"><p v-html="content"></p></div> 
                		<div class="sms_foot"></div>
                	</div>
                	<span>{{time}}</span>
                </div>
                 <div class="send_view_right">
                	 <img class="tips" src="../../assets/images/tips.png">
                	 <span>短信预览提示:</span>
                	 <p>1.请检查短信模板中的变量是否正确，一旦审核通过，若修改模板需再次提交平台审核！</br>
2.短信最终发送文字内容尽量控制在200字内。</br>
3.如有疑问，请致电安云信技术支持：028-85071717
</p><img class="icon" src="../../assets/images/icon-1.png">
                </div>

	      </div>
		  <div class="pagessss">
		     
			<div class="submits2111">
		        <button @click="back()">返回</button>
		     </div>
		 </div>
		 

	</div>
</template>
<script>
import u_center from '@/components/u_center.vue'; 
	export default {
	    components: {
		  u_center,
	    },
		data() {
			return {
				 content:"",
				 template_id:"",
				 token:"",
				 time:"",
				 code:"",
				 signname:""
			}
		}, 
		mounted() {
		       let self=this;
			   
  
			  this.code = this.$utils.getUrlKey('code');	
                 if(this.code){
                 	this.content=localStorage.getItem("template"+this.code);
                 	this.signname=localStorage.getItem("signname"+this.code);	
                 	this.content='【'+this.signname+'】'+this.content;	
                 }
			  this.nowtime();
		      var token= localStorage.getItem("token");
			  if(!token){
					 self.$router.push("/");  
			  }else{
			      self.token=token;
				//  self.get_templete_view();
			  }  
		}, 
		methods: {
			nowtime(){
                          var date = new Date();
					 var hours = date.getHours();
					if (hours < 10)
						hours = "0" + hours;
					var minutes = date.getMinutes();
					if (minutes < 10)
						minutes = "0" + minutes;
					var time = hours+":"+minutes   ;
					this.time=time;
			},
		    back(){
			   this.$router.go(-1)
			},
		    home(){
			  this.$router.push("/");  
			},		 
		     get_templete_view(){	        
				  let self=this;
				  axios.post(this.$api+'/message/get_templete_view', {
						   token:self.token,
						   template_id:self.template_id
				  }).then(function (response) {  
					  let data=response.data;
					  if(data.state==1){                
						    self.content=data.data;	
						  // var replacestr = document.getElementById("showcontent").innerHTML;
	                                self.content = self.content.replace(/{/g, "<font color=red>{");
	                                self.content = self.content.replace(/}/g, "}</font>");
	                                //document.getElementById("showcontent").innerHTML = replacestr;    							
					  }  
				  }).catch(function (error) {
						 
				  });
		    }, 
		     
		},watch:{
			 
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/sms/templete_view2.vue